import axios from 'axios';

const createDepartments = async (token, values, edit = false) => {
  try {
    let url;
    if (!edit) url = 'receipt-departments/create';
    else url = '/receipt-departments/update';

    const res = await axios.post(url, values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default createDepartments;
